import React from "react";
import { Outlet } from "react-router-dom";

const Beheer = () => {
    return (
        <Outlet />
    )
};

export default Beheer;